var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.fromData.title,
            visible: _vm.dialogVisible,
            width: _vm.fromData.width,
            "wrapper-closable": false,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "body" }, [
            _c(
              "div",
              { staticClass: "mt14" },
              [
                _vm.fromData.data
                  ? _c(
                      "el-form",
                      {
                        ref: "form",
                        attrs: {
                          model: _vm.form,
                          rules: _vm.rules,
                          "label-width": "90px",
                        },
                      },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "物资名称：" } },
                                  [_vm._v(_vm._s(_vm.fromData.data.name))]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.fromData.type !== 4
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "物资编号：" } },
                                      [_vm._v(_vm._s(_vm.fromData.data.number))]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "物资分类：" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.fromData.data.cate.cate_name)
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "物资型号：" } },
                                  [_vm._v(_vm._s(_vm.fromData.data.units))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.fromData.type === 3
                          ? [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { "margin-bottom": "10px" },
                                  attrs: { label: "维修原因：" },
                                },
                                [_vm._v(_vm._s(_vm.markDefault.mark))]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "维修处置：", prop: "other" },
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.form.other,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "other", $$v)
                                        },
                                        expression: "form.other",
                                      },
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 0 } }, [
                                        _vm._v("入库 "),
                                        _c("span", [
                                          _vm._v(
                                            "(入库之后该物资进入仓库，状态为未使用，可重新领用)"
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("el-radio", { attrs: { label: 4 } }, [
                                        _vm._v("报废 "),
                                        _c("span", [
                                          _vm._v(
                                            "(报废之后该物资状态为已报废，不可进行领用)"
                                          ),
                                        ]),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "花费(元)：", prop: "price" },
                                },
                                [
                                  _c("el-input-number", {
                                    attrs: {
                                      precision: 2,
                                      "controls-position": "right",
                                      size: "small",
                                      min: 0,
                                    },
                                    model: {
                                      value: _vm.form.price,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "price", $$v)
                                      },
                                      expression: "form.price",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.fromData.type === 4
                          ? [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "mt14",
                                  attrs: {
                                    label: "入库数量：",
                                    prop: "number",
                                  },
                                },
                                [
                                  _c("el-input-number", {
                                    attrs: {
                                      controls: false,
                                      min: 0,
                                      precision: 0,
                                      size: "small",
                                      placeholder: "请输入入库数量",
                                    },
                                    model: {
                                      value: _vm.form.number,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "number", $$v)
                                      },
                                      expression: "form.number",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "单价(元)：",
                                    prop: "prices",
                                  },
                                },
                                [
                                  _c("el-input-number", {
                                    attrs: {
                                      controls: false,
                                      min: 0,
                                      precision: 2,
                                      size: "small",
                                      placeholder: "请输入单价",
                                    },
                                    model: {
                                      value: _vm.form.prices,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "prices", $$v)
                                      },
                                      expression: "form.prices",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "mt14",
                            attrs: {
                              label: _vm.fromData.label + "：",
                              prop: "mark",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                placeholder: _vm.fromData.placeholder,
                                maxlength: "100",
                                rows: 3,
                                resize: "none",
                                "show-word-limit": "",
                                clearable: "",
                              },
                              model: {
                                value: _vm.form.mark,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "mark", $$v)
                                },
                                expression: "form.mark",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("public.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    loading: _vm.loading,
                    type: "primary",
                  },
                  on: { click: _vm.handleAdd },
                },
                [_vm._v(_vm._s(_vm.$t("public.ok")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }